import { DateTime } from 'luxon';

import Validatable from '@/validator/Validatable';

export interface Geofence {
  created_on_utc: string;
  description: string;
  geojson: {
    coordinates: [number, number][];
    type: string;
  };
  hivestack_id: number;
  id: number;
  latitude: number;
  longitude: number;
  modified_on_utc: string;
  name: string;
  swarm_aws_region: string;
}

export interface ILiftAnalysisSummaryAPI {
  id: number;
  name: string;
  workflowexecution_id: number;
  created_on_utc: string;
}

export default class LiftAnalysisSummary extends Validatable {
  id: number;

  name: string;

  workflowExecutionID: number;

  createdOnUtc: DateTime;

  constructor(id: number, name: string, workflowExecutionID: number, createdOnUtc: DateTime) {
    super();
    this.id = id;
    this.name = name;
    this.workflowExecutionID = workflowExecutionID;
    this.createdOnUtc = createdOnUtc;
  }

  get description(): string {
    return `${this.createdOnFormatted} – ${this.name}`;
  }

  get createdOnFormatted(): string {
    return this.createdOnUtc.toLocal().toLocaleString(DateTime.DATETIME_SHORT);
  }

  static fromApi(apiObject: ILiftAnalysisSummaryAPI): LiftAnalysisSummary {
    return new LiftAnalysisSummary(
      apiObject.id,
      apiObject.name,
      apiObject.workflowexecution_id,
      apiObject.created_on_utc != null ? DateTime.fromISO(apiObject.created_on_utc, { zone: 'utc' }) : null,
    );
  }

  static fromObject(obj: LiftAnalysisSummary) {
    return super.fromObject(obj, new LiftAnalysisSummary(obj.id, obj.name, obj.workflowExecutionID, obj.createdOnUtc));
  }

  toApi(): ILiftAnalysisSummaryAPI {
    return {
      id: this.id,
      name: this.name,
      workflowexecution_id: this.workflowExecutionID,
      created_on_utc: this.createdOnUtc?.toJSDate().toISOString(),
    };
  }

  static validatorCreateRules() {
    return {};
  }
}
